import { Col } from "antd";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ServerSideDataGrid } from "../../../common/components/serverSideDataGrid/serverSideDataGrid";
import { Columns } from "./columns";
import Candidate from "../../../redux/models/candidate";
import K from "../../../utilities/constants";
import { selectUserId } from "../../../redux/slices/userSlice";
import { selectSelectedClientIds } from "../../../redux/slices/globalSelectorSlice";
import { UploadCsvButton } from "../../clients/details/jobs/jobsContainer/uploadScvButton/uploadCsvButton";
import { usePageFilter } from "../../../hooks/usePageFilters";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";

export const CandidatesContainer = () => {
  const history = useHistory();

  const clients = useSelector(selectSelectedClientIds);
  const userId = useSelector(selectUserId);

  const [search, setSearch] = usePageFilter("candidates_search");

  const getServerSideData = useCallback(
    (options) => {
      return Candidate.v2.get({
        ...options,
        client: clients,
        search: search || undefined,
      });
    },
    [clients, search],
  );

  return (
    <DataTableLayout
      searchDefaultValue={search}
      onSearchChange={setSearch}
      actions={[
        {
          permissions: [K.Permissions.UploadJobCSV],
          renderer: () => (
            <Col>
              <UploadCsvButton />
            </Col>
          ),
        },
      ]}
    >
      <ServerSideDataGrid
        userId={userId}
        configKey={K.AgGridTable.Keys.Candidates}
        getData={getServerSideData}
        defaultColumnConfig={Columns}
        rowStyle={{ cursor: "pointer" }}
        onRowClicked={(event) =>
          history.push(`/candidates/detail/${event.data.id}`)
        }
      />
    </DataTableLayout>
  );
};
